import type ApolloClient from 'apollo-client';
import { matchPath } from 'react-router-dom';
import pages from './pages';

export type PreloadContext = {
  apiClient: ApolloClient<unknown> | null;
  /** Known once login returns. The code part of a preload runs without it. */
  userId?: string;
};

/**
 * Starts loading what the route for `pathname` needs: its code, and, with a
 * user id, its first query. Safe to call again once the user id is known.
 * Nothing to wait for and nothing that can fail the caller: the route loads
 * for itself when it renders.
 */
export function preloadRoute(pathname: string, context: PreloadContext) {
  // An unknown path is redirected to the first route, so that is what loads.
  const page =
    pages.find(({ path, exact }) => matchPath(pathname, { path, exact })) ??
    pages[0];
  try {
    Promise.resolve(page.preload?.(context)).catch(() => {});
  } catch {
    // A synchronous throw is the same non-event as a rejection.
  }
}
